/**
 * The display name for the AI Concierge assistant.
 *
 * Single source of truth for the attendee-facing and admin-facing name. Change
 * this one value to rename the assistant everywhere in the UI (widget header,
 * FAB tooltip/aria-label, empty-state copy, admin toggle labels).
 *
 * Note: this is the *display* name only. Backend routes, config flags, DB tables,
 * and API paths keep the neutral "concierge" identifier so a rename never touches
 * the wire contract or data model.
 */
export const CONCIERGE_NAME = 'Casey'
